"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTACHMENT_EXTS_ALLOWED = exports.ATTACHMENT_MIME_TYPE_ALLOWED = exports.MAX_ATTACHMENT_SIZE = exports.InquiryConfigSchema = exports.InquiryRelativeTo = exports.InquiryStatus = void 0;
const zod_1 = require("zod");
var InquiryStatus;
(function (InquiryStatus) {
    InquiryStatus["RESOLVED"] = "RESOLVED";
    // creditor waiting by response
    InquiryStatus["WAITING_FOR_RESPONSE"] = "WAITING_FOR_RESPONSE";
    // admin waiting by response
    InquiryStatus["WAITING_FOR_INTERACTION"] = "WAITING_FOR_INTERACTION";
})(InquiryStatus = exports.InquiryStatus || (exports.InquiryStatus = {}));
var InquiryRelativeTo;
(function (InquiryRelativeTo) {
    InquiryRelativeTo["PayoutDate"] = "payout_date";
    InquiryRelativeTo["StartDate"] = "start_date";
    InquiryRelativeTo["EndDate"] = "end_date";
})(InquiryRelativeTo = exports.InquiryRelativeTo || (exports.InquiryRelativeTo = {}));
exports.InquiryConfigSchema = zod_1.z.object({
    relative_to: zod_1.z.nativeEnum(InquiryRelativeTo),
    duration: zod_1.z.object({
        days: zod_1.z.coerce.number(),
    }),
});
exports.MAX_ATTACHMENT_SIZE = 5 * 1024 * 1024; // 5MB
exports.ATTACHMENT_MIME_TYPE_ALLOWED = [
    'pdf',
    'jpeg',
    'png',
    'jpg',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'vnd.ms-excel',
];
exports.ATTACHMENT_EXTS_ALLOWED = ['.pdf', '.jpeg', '.png', '.jpg', '.xlsx', '.xls'];
